import React from 'react'
import CoffeeButton from '../Funciones/CoffeeButton'

const NavNar1 = () => {
  return (
    <div className='buto'>
        <CoffeeButton/>
    </div>
  )
}

export default NavNar1